<template>
  <div>
    <VForm
      :name="name"
      :fields="formData.fields"
      :disabled="!isValid"
      :initialValues="initialValues"
    ></VForm>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import VForm from "@/components/VForm";
import withForm from "@/mixins/withForm";
import { email } from "@/utils/validations";

export default Vue.component("AccountSettingsForm", {
  props: {
    initialValues: VueTypes.any
  },

  components: {
    VForm
  },

  mixins: [withForm],

  data() {
    return {
      name: "accountSettings",
      formData: {
        fields: [
          {
            name: "daily_reports",
            label: "Daily summary of sent mail",
            elementType: "checkbox",
            extraClass: "account-settings-email-checkbox"
          },
          {
            name: "monthly_reports",
            label: "Monthly summary of sent mail",
            elementType: "checkbox",
            extraClass: "account-settings-email-checkbox"
          },
          {
            name: "emails",
            label: "Who should receive notifications",
            placeholder: "Add email...",
            elementType: "tagsCreator",
            extraClass: "notifications-emails",
            valueValidationFunc: email,
            preventEllipsis: true
          }
        ]
      }
    };
  }
});
</script>

<style lang="scss" scoped>
.description {
  color: grey;
  margin-top: 10px;
  font-size: 12px;
  font-style: italic;
}
</style>

<style lang="scss">
.v-checkbox.account-settings-email-checkbox {
  margin-top: 14px;
  display: block;

  label {
    font-size: 16px;
    margin-left: 15px;
  }
}

.v-ta__wrapper.settings-email-receipients {
  label {
    font-size: 15px;
  }
  margin-top: 25px;
}

.notifications-emails {
  margin-top: 55px;
}
</style>
